import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Flame } from "lucide-react";

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const run = async () => {
      if (!sessionId) { navigate("/"); return; }
      try {
        const res = await api.post("/auth/session", { session_id: sessionId }, { headers: { "X-Session-ID": sessionId } });
        setUser(res.data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/profile", { state: { user: res.data.user } });
      } catch (e) {
        navigate("/login");
      }
    };
    run();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#0B0C0E]">
      <Flame className="w-12 h-12 text-amber-500 animate-pulse" />
      <p className="mt-4 text-stone-400 font-mono text-sm">…</p>
    </div>
  );
};

export default AuthCallback;
